export const ensureEnv = (envName: string) => {
  if (!import.meta.env[envName]) {
    throw new Error(`Missing env variable: ${envName}`)
  }
  return import.meta.env[envName]!
}

const env = {
  apiEndpoint: ensureEnv("VITE_API_ENDPOINT"),
  // mapboxAccessToken: ensureEnv("VITE_MAPBOX_ACCESS_TOKEN"),
}

export default env
